/* eslint-disable camelcase */
type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_high_quality_on_demand_yoga_meditation_and_breathwork_classes: Phrase =
    locale => {
        const en = `High-quality on demand yoga, meditation and breathwork classes to meet you where you are, on your schedule.`;
        const phrases: { [key: string]: undefined | string } = {
            en,
            es: `Clases de yoga y meditaciones de alta calidad para que puedas practicar en cualquier lugar y a cualquier hora.`,
        };
        return phrases[locale] || en;
    };
